import { BaseContract } from './common/base.contract';
import { Contract, JsonRpcProvider } from 'ethers';
import DiamondInitAbi from '../abi/DiamondInit.json';

export class DiamondInit extends BaseContract {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, DiamondInitAbi.abi, provider));
    }

    init = async () => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.init();
        await tx.wait();
    }
} 
